module.exports = __webpack_public_path__ + "img/tl.f34c9a01.svg";